import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const UsuarioSOLFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='USUARIO SOL' htmlFor='input-usuarioSOL' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='usuarioSOL'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-usuarioSOL' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsuarioSOLFormGroup)
